import {defineNuxtPlugin} from '#app'
import {useRoute} from 'vue-router'
import {watch} from 'vue'

/**
 * Plugin that watches the current route and tidies up stores accordingly.
 * Prevents stale data and confusing redirections.
 */
export default defineNuxtPlugin((nuxtApp) => {
    const route = useRoute()

    watch(
        () => route.fullPath,
        (newPath) => {
            const currentRoute = localStorage.getItem('sbl.currentRoute')
            if (route.path !== currentRoute && !(route.path?.includes('loading') || route.path?.includes('login'))) {
                localStorage.setItem('sbl.currentRoute', route.path)
            }
        }
    )
})
